export default __webpack_public_path__ + "static/media/icon-check-fees.418c39a1.svg";